<div class="container">
  <div class="icons">
    <span class="item-toggle">Gerar:</span>
    <div class="pdf-icon">
      <span class="fas fa-file-pdf fa-lg" (click)="downloadPdfCursosConvergentes()"></span>
    </div>
    <div class="csv-icon">
      <span class="fas fa-file-csv fa-lg" (click)="downloadCsvCursosConvergentes()"
        matTooltip="Exportar cursos para CSV" matTooltipPosition="above"></span>
    </div>
  </div>
  <br />
  <h1 class="title text-center">Tabela de Convergência</h1>

  <p class="text-justify">
    A tabela de convergência é uma lista que estabelece a relação entre as denominações de cursos técnicos que já foram
    adotadas por algumas instituições de ensino, e que devem ser adaptadas por aquelas constantes do Catálogo, caso o
    curso esteja em funcionamento.
    A Tabela de Convergência serve, também, de parâmetro para aqueles estudantes que concluíram seus cursos antes da
    edição vigente do Catálogo, indicando com qual curso do Catálogo a sua formação estaria mais próxima.
    Destaca-se que a relação entre os cursos não é direta, pois uma mesma denominação pode apontar para diferentes
    cursos do Catálogo.
    Por exemplo: o Técnico em Laboratório tanto pode convergir para o Técnico em Análises Clínicas quanto para Técnico
    em Citopatologia, por isso é preciso uma análise detalhada do curso feito para apontar qual a convergência mais
    apropriada.
  </p>
  <br />
  <app-barra-busca [componenteRef]="componenteRef" (inputEvent)="recebeuInput($event)"></app-barra-busca>
  <p *ngIf="!totalResultados || (!totalResultados && realizouBusca) || msgSemCurso" class="text-center results">
    Desculpe, não encontramos nenhum resultado compatível com sua busca.
  </p>
</div>


<div class="container">
  <table class="table table-bordered">
    <!-- <tbody *ngFor="let curso of cursosTabelaConvergencia"> -->
    <tbody *ngFor="let curso of pagedItems">
      <tr scope="col" class="bg-color-table-convergencia-title-eixo">
        <td colspan=2 class="text-center">
          <span [innerHTML]="curso.eixoNome | highlight : stringPesquisa"></span>
        </td>
      </tr>
      <tr scope="col" class="bg-color-table-convergencia-title-cursos">
        <td>Denominação Atual</td>
        <td>Denominações Anteriores</td>
      </tr>
      <tr>
        <!-- <td>{{ curso.nome | highlight : stringPesquisa}}</td> -->
        <td [innerHTML]="curso.nome | highlight : stringPesquisa"></td>
        <td>
          <ul class="course-item" *ngIf="curso.cursosMudaramNomeCncts && curso.cursosMudaramNomeCncts.length > 0">
            <li *ngFor="let cursoMudouNome of curso.cursosMudaramNomeCncts ">
              <!-- {{ cursoMudouNome.nome }} -->
              <span [innerHTML]="cursoMudouNome.nome | highlight : stringPesquisa"></span>
            </li>
          </ul>
          <ul class="course-item" *ngIf="curso.cursosMudaramNomeCncts && curso.cursosMudaramNomeCncts.length < 1">
            <li>
              Não Houve alteração
            </li>
          </ul>
        </td>
      </tr>
      <tr scope="col">
        <td colspan=2></td>
      </tr>
    </tbody>
  </table>
  <ng-container *ngIf="totalResultados > 0">
    <app-paginacao [paginaAtual]="paginaAtual" [totalPaginas]="totalPaginas"
      (mudouPagina)="onPaginaSelecionada($event)"></app-paginacao>
  </ng-container>
</div>